export enum SessionTypes {
    SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED',
    SET_REQUEST_STATUS = 'SET_REQUEST_STATUS',
    SET_TOKEN_LIFE_TIME = 'SET_TOKEN_LIFE_TIME',
    SET_REQUEST_DATE = 'SET_REQUEST_DATE',
    SET_LOGGED_USER = 'SET_LOGGED_USER',
    RESET_LOGGED_USER = 'RESET_LOGGED_USER'
}